module.exports = __webpack_public_path__ + "img/F2.346dfa6c.png";